import React from "react";
import PropTypes from "prop-types";
import { Tag } from "orcs-design-system";
import { getTagLabel } from "src/util/tags";

const HashTag = ({ element, selected, focused, tagTypeLabel }) => {
  const { tag } = element;
  const { type, tagTypeName } = tag || {};
  const mentionText = (element?.children || [])
    .map((child) => child?.text || "")
    .join("");
  const mentionLabel = mentionText.match(/^#\[(.*)\]$/)?.[1];
  const resolvedTypeLabel = tagTypeLabel || tagTypeName || type;
  const label = getTagLabel(tag) || mentionLabel || resolvedTypeLabel;

  return (
    <Tag
      m="xxs"
      variant={selected || focused ? "selected" : "default"}
      tagType={
        resolvedTypeLabel && resolvedTypeLabel !== label
          ? resolvedTypeLabel
          : undefined
      }
      small
    >
      #{label}
    </Tag>
  );
};

HashTag.propTypes = {
  element: PropTypes.object,
  selected: PropTypes.bool,
  focused: PropTypes.bool,
  tagTypeLabel: PropTypes.string,
};

export default HashTag;
